import { useEffect } from "react";
import { Alert, Form, Input, Modal, Typography } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";

const { Text } = Typography;

export default function EnabizRemoveKosModal({ row, open, onClose, onSuccess }) {
    const [form] = Form.useForm();

    useEffect(() => {
        if (open) form.resetFields();
    }, [open])

    const onFinish = async ({ studyInstanceUid }) => {
        const res = await ApiService.AppointmentTeletip.RemoveKos(row.id, studyInstanceUid.trim());
        if (res.success) {
            onSuccess && onSuccess();
            onClose && onClose();
        }
    }

    return (
        <Modal
            title={t('Remove KOS')}
            open={open}
            onCancel={onClose}
            onOk={() => form.submit()}
            okText={t('Remove')}
            okButtonProps={{ danger: true }}
            cancelText={t('Cancel')}
            destroyOnClose
        >
            {row && (
                <div style={{ marginBottom: 12 }}>
                    <Text type="secondary">{row.patientName} {row.patientLastname} - {row.operationName}</Text>
                    <div><Text type="secondary">Accession: <Text code>{row.accessionNumber || '-'}</Text></Text></div>
                </div>
            )}
            <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12 }}
                message={t('This action removes the Teletip KOS record permanently.')}
            />
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item
                    label={t('Study Instance UID')}
                    name="studyInstanceUid"
                    rules={[{ required: true, message: t('Study Instance UID is required.') }]}
                >
                    <Input placeholder="1.2.840.113619.2.55.3..." />
                </Form.Item>
            </Form>
        </Modal>
    )
}
